import styled from "styled-components";

export const StyledWrapper = styled.div`
  margin: 8px;

  &.loading {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 474px;

    > div {
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, -50%);
      width: 200px;
      height: 200px;

      > svg {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
`;
